import { styled, SpacingStack, Box, Flex, StyleSystemProps, LinkV2 } from '@withjoy/joykit';
import { CSSProperties } from 'react';
import { pxToRem } from '@withjoy/joykit/theme';
import { CSSObject } from '@withjoy/joykit/components/Box/Box.types';
import { ReactComponent as AddIconSvg } from '@assets/icons/circle-plus.svg';

export const StyledWrapper = styled(Box)``;
export const StyledPageBox = styled(SpacingStack)``;
export const StyledStepColumn = styled(Flex)``;
export const StyledLottieWrapper = styled(Flex)``;
export const StyledAddButton = styled(LinkV2)``;
export const StyledAddIcon = styled(AddIconSvg)``;
export const StyledVideoWrapper = styled(Box)``;
export const StyledFooterColumn = styled(Flex)``;
export const StyledVideo = styled.video``;
export const StyledLinkV2 = styled(LinkV2)`
  text-underline-offset: 3px;
  text-decoration-color: ${props => props.theme.colors.mono5};
`;

const wrapperStyles: StyleSystemProps = {
  maxWidth: ' 100%',
  minHeight: 'inherit',
  display: 'flex',
  margin: '0 auto',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  paddingX: 6
};

const pageBoxStyles: StyleSystemProps = {
  maxWidth: '1104px',
  width: {
    _: '100%',
    md2: pxToRem(712)
  }
};

const stepColumnStyles: StyleSystemProps = {
  marginTop: '0 !important',
  flexDirection: 'column',
  alignItems: 'flex-start'
};

const lottieArrowStyles: CSSObject = {
  width: 'auto',
  height: pxToRem(120),
  position: 'absolute',
  bottom: 0,
  right: '-7rem',
  ['& svg']: {
    width: `${pxToRem(100)} !important`,
    height: `${pxToRem(120)} !important`
  }
};

const addButtonStyles: StyleSystemProps = {
  cursor: 'grab',
  width: 175,
  height: 48,
  borderRadius: '24px',
  fontWeight: 600,
  color: 'white',
  backgroundColor: 'mono14',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textDecoration: 'none',
  _hover: {
    backgroundColor: 'gray13'
  },
  _active: {
    cursor: 'grabbing',
    backgroundColor: 'mono14'
  }
};

const iconStyles: CSSProperties = {
  marginRight: '8px',
  width: '24px',
  height: '24px'
};

const safariVideoWrapperStyles: StyleSystemProps = {
  width: { sm: pxToRem(380), sm2: pxToRem(530), md: pxToRem(492) },
  minHeight: { sm: pxToRem(160), sm2: pxToRem(310), md: pxToRem(320) },
  marginLeft: 'auto',
  marginRight: 'auto',
  marginTop: 32
};

const videoWrapperStyles: StyleSystemProps = {
  ...safariVideoWrapperStyles,
  marginTop: 32,
  marginBottom: 0
};

const videoStyles: CSSProperties = {
  objectFit: 'cover',
  width: '100%',
  height: '100%'
};

const footerColumnStyles: StyleSystemProps = {
  marginTop: `${pxToRem(8)} !important`,
  flexDirection: 'column',
  alignItems: 'flex-center'
};

export const styles = {
  wrapper: wrapperStyles,
  pageBox: pageBoxStyles,
  stepColumn: stepColumnStyles,
  lottieArrow: lottieArrowStyles,
  addButton: addButtonStyles,
  icon: iconStyles,
  safariVideoWrapper: safariVideoWrapperStyles,
  videoWrapper: videoWrapperStyles,
  video: videoStyles,
  footerColumn: footerColumnStyles
};
